// extracted by mini-css-extract-plugin
module.exports = {"payment-profile":"PaymentModal_payment-profile__2vbwX","payment-header":"PaymentModal_payment-header__2geqT","modal-content":"PaymentModal_modal-content__2JyDS"};